/**
 * @file RingProgressbar component
 */

import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import Manipulator from '../../utils/dom/manipulator';

const NAME = 'CreditoMeter';

class CreditoMeter extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		const actualValue = Manipulator.getDataAttribute(this._element, 'actual-value');
		const totalValue = Manipulator.getDataAttribute(this._element, 'total-value');
		let percentage = actualValue * 100 / totalValue;
		if(percentage > 100) {
			percentage = 100;
		}
		this._element.style.setProperty('--percentage', percentage);
		const progressText = SelectorEngine.findOne('.progress-text', this._element);
		progressText.textContent = actualValue;
	}
}
export default CreditoMeter;
